import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../redux/actions/auth.actions";
import ListErrors from "../components/ListErrors";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email(i18n.t("auth.form_email_invalid_error"))
    .required(i18n.t("auth.form_email_required_error")),
  password: Yup.string()
    .min(3, i18n.t("auth.form_password_invalid_error"))
    .required(i18n.t("auth.form_password_required_error"))
});

function Login() {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const handleSubmit = (email, password) => dispatch(login(email, password));

  return (
    <Translation>
      {t => (
        <div id="focus">
          <div id="focus-header">
            <h1> {t("system.project_name")}</h1>
          </div>
          <div className="main">
            <div className="main-wrap">
              <div className="focus-wrap">
                <h2>{t("auth.login_title")}</h2>
                <Formik
                  initialValues={{ email: "", password: "" }}
                  validationSchema={LoginSchema}
                  onSubmit={(payload, { setSubmitting }) => {
                    handleSubmit(payload.email, payload.password);
                    setSubmitting(false);
                  }}
                >
                  {({ touched, errors, isSubmitting }) => (
                    <Form>
                      <div className={`form-item `}>
                        <label htmlFor="email">{t("auth.label_email")}</label>
                        <Field
                          name="email"
                          type="email"
                          placeholder={t("auth.input_email_placeholder")}
                        />
                        <ErrorMessage
                          name="email"
                          className="error-message"
                          component="div"
                        />
                      </div>
                      <div className={`form-item`}>
                        <label htmlFor="password">
                          {t("auth.label_password")}
                        </label>
                        <Field
                          type="password"
                          name="password"
                          placeholder={t("auth.input_password_placeholder")}
                        />
                        <ErrorMessage
                          name="password"
                          className="error-message"
                          component="div"
                        />
                      </div>
                      <ListErrors errors={auth.errors} />
                      <div className="form-item">
                        <button type="submit" disabled={isSubmitting}>
                          {isSubmitting
                            ? t("system.submitting_feeback")
                            : t("auth.login_button")}
                        </button>
                      </div>
                      {
                        <div className="form-item form-prompt">
                          <Link to={"/interest"}>
                            <span className="sharp">
                              {t("auth.interest_prompt")}
                            </span>{" "}
                            {t("auth.interest_text")}
                          </Link>
                        </div>
                      }
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Login;
